import { addStyles } from 'ethcss'
import { grid, mediaCSS, IStyles, colors, layers } from '../../../theme'
import { textSizes } from 'theme/media'
import { defaultThemeStyles as defaultThemeAppStyles } from 'blocks.app/app/app.theme.jcss'

const mediaHeightQuery = '@media (max-height: 960px)'
const mediaWidth600pxQuery = '@media (max-width: 600px)'

const displaysAddStyles: IStyles = {
    wrapper: {
        ...grid.col,
        ...grid.justify,
        ...grid.full,
        ...grid.p_md,
    },
    deviceParametersWrapper: {
        ...grid.col,
        ...grid.justify,
        ...grid.fullWidth,
        minHeight: '100%',
        boxSizing: 'border-box',
        padding: '32px 24px 24px',
        [mediaCSS.tabMini]: {
            height: 'auto',
            paddingRight: 37,
        },
        backgroundColor: `var(--var-module-app-component-app-style-panel, ${defaultThemeAppStyles.panel})`,
    },
    formWrapper: {
        width: '54%',
        ...grid.row,
        [mediaWidth600pxQuery]: {
            height: '100%',
        },
        [mediaCSS.desktopXL]: {
            width: '65%',

            [mediaCSS.desktopML]: {
                width: '80%',

                [mediaCSS.desktopML]: {
                    ...grid.w100,
                },
            },
        },
    },
    form: {
        ...grid.row,
        ...grid.w100,
    },
    title: {
        fontWeight: 'bold',
        display: 'block',
        width: '100%',
        textAlign: 'center',
        fontSize: textSizes.mdPlus,
        flexShrink: 0,
        ...grid.mb_md,
        [mediaCSS.tabMini]: {
            fontSize: 20,
            padding: '0 40px',
        },
    },
    inputLabel: {
        ...grid.mb_micro,
        textTransform: 'uppercase',
        display: 'block',
        width: '100%',
        textAlign: 'center',
        fontSize: textSizes.normalPlus,
    },
    addressField: {
        position: 'relative',
        zIndex: layers.sticky,
    },
    addressSuggestions: {
        position: 'absolute',
        left: 0,
        right: 0,
        top: '100%',
        zIndex: layers.drop,
        marginTop: 4,
    },
    noBoxShadow: {
        boxShadow: 'none !important',
    },
    content: {
        ...grid.colCenter,
        ...grid.fullWidth,
        ...grid.space,
        minHeight: 0,
        [mediaCSS.tabMini]: {
            ...grid.mb_md,
        },
        [mediaHeightQuery]: {
            overflowY: 'auto',
        },
    },
    descriptionWrapper: {
        ...grid.w50,
        [mediaCSS.tabMini]: {
            ...grid.w100,
        },
    },
    leftColumnContent: {
        ...grid.col,
        ...grid.w45,
        ...grid.mr_md,
        [mediaCSS.tabMini]: {
            ...grid.w100,
            ...grid.mr_none,
        },
    },
    rightColumnContent: {
        ...grid.w50,
        [mediaCSS.tabMini]: {
            ...grid.w100,
            ...grid.row,
        },
    },
    footer: {
        ...grid.row,
        ...grid.center,
        [mediaCSS.tabMini]: {
            ...grid.mb_md,
        },
    },
    displaysAdd__inputWrapper_type_tags: {
        ...grid.mb_micro,
        [mediaCSS.tabMini]: {
            ...grid.w100,
        },
    },
    disabled: {
        opacity: 0.5,
    },
    noLicensesLeft: {
        display: 'flex',
        color: colors.notificationRed,

        span: {
            marginLeft: 10,
            fontSize: 11,
        },
    },
    licenseOption: {
        padding: 6,
        borderRadius: 5,
        backgroundColor: 'transparent',
        width: '100%',
        transition: 'background-color 0.3s',

        '&:hover': {
            backgroundColor: '#E9ECF1',
        },
    },
    licenseOptionRow: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    licenseOptionName: {
        fontWeight: 'bold',
    },
    licenseOptionDesc: {
        borderRadius: 5,
        backgroundColor: '#F2F4F7',
        fontWeight: 'normal',

        span: {
            color: colors.blueAccent,

            span: {
                color: 'rgba(37, 130, 224, 0.50)',
            },
        },
    },
    licenseHeaderDesc: {
        borderRadius: 5,
        backgroundColor: 'transparent',
        fontWeight: 'normal',

        span: {
            color: colors.blueAccent,

            span: {
                color: 'rgba(37, 130, 224, 0.50)',
            },
        },
    },
    lic: {
        [mediaCSS.tabMini]: {
            width: '100%',
        },
    },
    orientationWrapper: {
        textAlign: 'center',
        marginBottom: 24,
    },
    orientationTitle: {
        fontSize: 16,
        textTransform: 'uppercase',
        marginBottom: 10,
    },
}

addStyles(displaysAddStyles)
export default displaysAddStyles
